<template>
  <AppBorderedSection
    :section-number="sectionNumber"
    :thick-border="isCurrent || thickBorder"
  >
    <div
      class="item-link title font-weight-bold"
      :class="textClass"
      @mouseenter="mouseenter"
      @mouseleave="mouseleave"
      @click="goToSection"
    >
      {{ $t(`content.sections.${section}.title.lead`) }}
    </div>
  </AppBorderedSection>
</template>

<script>
import AppBorderedSection from "@/components/AppBorderedSection.vue";
export default {
  components: {
    AppBorderedSection
  },
  props: {
    section: {
      type: String,
      required: true
    },
    sectionNumber: {
      type: Number,
      required: true
    },
    isCurrent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      thickBorder: false
    };
  },
  computed: {
    textClass() {
      return this.sectionNumber
        ? `section${this.sectionNumber}--text`
        : "primary--text";
    }
  },
  methods: {
    mouseenter() {
      this.thickBorder = true;
    },
    mouseleave() {
      this.thickBorder = false;
    },
    goToSection() {
      this.$vuetify.goTo(`#section-${this.sectionNumber}`);
    }
  }
};
</script>

<style scoped>
.item-link {
  cursor: pointer;
}
</style>